module.exports = __webpack_public_path__ + "media/landing_page/store-icon-ca2d9a31.svg";